import { DemoSideComponents } from "../componentsUtils/DemoSideComponents";

import chroma from "chroma-js"

// ToDo: Where to configure icons to use (by design style/template)
import Download from '../svg/NewSecSVG/Download.svg'
import GetLink from '../svg/NewSecSVG/SendLink.svg'
import { Localization, Cookies, MitCookies, actionSetInfoMessage, AppMessagesContext, SessionContext, SessionActionType, actionSetLoginDialogMode, LoginDialogMode, SettingsManager, UserHelpContext, showReleases, showUserGuide, LicenseStateCompact, LanguageSelector, LicensingContext, actionSetErrorMessage, actionLogoff, actionDisableLicense, actionSwapLicenseVariant } from '@viamap/viamap2-common';
import { RightPaneContext, RightPaneModus, actionGoToModus, actionToggleBurgerMenu, actionToggleModus } from 'src/states/RightPaneState';
import { ProtectedFeature } from './ProtectedFeature';
import { ApplicationStateContext, Feature } from 'src/states/ApplicationState';
import Dashboard from './Dashboard';
import { Projects } from './Projects';
// import { CompleteMultipleCatchmentDialog } from './MultipleCatchmentDialog';
import { MapInteractionState, MapitStateContext, actionAddDataLayer, actionSetMapInteractionState, actionSetMapInteractionStateDefault, actionSetPoiTypesToShow } from 'src/states/MapitState';
import React, { Fragment, useContext, useEffect, useId, useState } from 'react';
import { PoiSelector } from './PoiSelector';
import { DrawingTools } from './DrawingToolsV2';
import { LayerFunc } from 'src/managers/LayerFunc';
import { DynamicDataDrivenLayerPOI } from 'src/managers/DynamicDataDrivenLayer';
import { POIS } from 'src/HLED/managers/PoiManager';
import { LayerInfo, MarkerType } from 'src/common/managers/Types';
import { DeviceScreenSize } from 'src/states/ApplicationStateFeatureMapping';
import { LayerContainer } from './LayerContainer';
import { ExtendedMenuButton, MenuButton, VLine, SidePanelScrolling } from './MitGlassComponents';
import { MapitButtonsAndOverlays } from './MapitButtonsAndOverlays';
import { actionGenerateCatchmentSimple, actionSetCatchmentState, CalculationMode, CatchmentState, CatchmentStateContext } from 'src/states/CatchmentState';
import { CatchmentSelector } from './CatchmentSelector';
import { CatchmentInterface } from 'src/managers/CatchmentInterface';
import { ExportData } from 'src/managers/ExportData';
import { licenseVariantToRoles } from 'src/states/ApplicationStateVariantMapping';
import { NavigationBarMicro } from "./NavigationBarMicro"
import { TSwitch } from "./TSwitch"
import { actionSimulateExpiredLicense, actionSimulateInvalidLicense } from "@viamap/viamap2-common/dist/states/ViamapLicensingState"
import { MitStorage } from "src/managers/MitStorage"
import { BNBOContext } from "src/modules/BNBOModule/BNBOState"
import { message } from "./Message"
import { NonBlockingError } from "./NonBlockingError"
import { AdvancedDragModalMiniContainer } from "src/componentsUtils/AdvancedDragModalMiniContainer"
import { closeWindow, openWindow, WindowId } from "src/WindowManager/WindowState"
import { useWindowContext } from "src/WindowManager/useWindowContext"
import { ActionTracker } from "src/common/managers/ActionTracker";
import { MIBIcon } from "src/componentsUtils/MIBIcon";

export default function RightPane(props: { children: React.ReactNode }) {
  const { state: rightPaneState } = useContext(RightPaneContext)
  const [showBlockBar, setShowBlockBar] = useState(true);
  const [showDebugModal, setShowDebugModal] = useState(false);

  return (
    <>
      {props.children}
      <div id='Mit-ApplicationOverlay' >
        <SideBarBlockAll show={showBlockBar} >
          <NavigationBarMicro onCollapse={() => {
            setShowBlockBar((a) => {
              ActionTracker.track("RightPane", "Sidebar", a ? "Close" : "Open", {})
              return !a
            })
          }} />

          <BurgerMenu show={rightPaneState.showBurgerMenu} setShowDebugModal={setShowDebugModal} />
          <SideBarNonBlocking show={true} >
            <></>
          </SideBarNonBlocking>
          <MapitButtonsAndOverlays />

        </SideBarBlockAll>

      </div>
      {showDebugModal && <DemoSideComponents onClose={() => setShowDebugModal(false)} />}
    </>
  )
}

function SideBarBlockAll(props: { show: boolean, children }) {
  return (<>
    {props.show ? <BlockingElements /> : null}
    <div id='Mit-NonBlockingOverlay'>
      <NonBlockingError />
      <div className="MapCorners c1" ></div>
      <div className="MapCorners c2" ></div>
      <div className="MapCorners c3" ></div>
      <div className="MapCorners c4" ></div>
      <div className="MapCorners c5" ></div>
      {props.children}
    </div>
  </>)
}

function SideBarNonBlocking(props: { show: boolean, children }) {
  if (!props.show) {
    return <div id='Mit-MapOverlay'>
      <AdvancedDragModalMiniContainer />
      {props.children}
    </div>
  }
  return (<>
    <NonBlockingElements />
    <div id='Mit-MapOverlay'>
      <AdvancedDragModalMiniContainer />
      {props.children}
    </div>
  </>)
}

function BlockingElements() {
  const { isActive } = useContext(RightPaneContext)

  return (
    <>
      <SubMenu />
      <SubSubMenuMap show={isActive(RightPaneModus.Map)} />
    </>
  )
}

function NonBlockingElements() {
  const { isActive } = useContext(RightPaneContext);
  const { state: applicationState } = useContext(ApplicationStateContext);
  const { state: windowState } = useWindowContext();


  return (
    <>
      <DrawingTools show={isActive(RightPaneModus.Map_Measure)} />
      <Dashboard show={isActive(RightPaneModus.Dashboard)} />
      <RenderOwnerShipDiagram show={isActive(RightPaneModus.Ejerskab)} />
      <RenderGenerateReport show={isActive(RightPaneModus.GeoDataRapport)} />
      <RenderSearchWindow show={isActive(RightPaneModus.Search)} />
      <ShareMapBar show={isActive(RightPaneModus.Map_Share)} />
      <Projects show={isActive(RightPaneModus.Projects)} />
      <POI show={isActive(RightPaneModus.Map_POI)} />
      <Discover show={isActive(RightPaneModus.Map_Discover)} />
      <RenderOwnerShipDiagram show={isActive(RightPaneModus.Map_Ownership)} />

      <LayerContainer show={
        isActive(RightPaneModus.Map_Layer) && (!(applicationState.deviceScreenSize == DeviceScreenSize.Phone) || (!windowState.find((e) => e.id === WindowId.ConfirmLayerList)))} />

      <CatchmentSideBar />
    </>
  )
}

const RenderGenerateReport = (props: { show: boolean }) => {
  const { dispatch: windowDispatch } = useWindowContext();

  useEffect(() => {
    if (props.show) {
      windowDispatch(openWindow(WindowId.DemographyReportDialog));
    } else {
      windowDispatch(closeWindow(WindowId.DemographyReportDialog));
    }
  }, [props.show])

  return (null);
}

const RenderSearchWindow = (props: { show: boolean }) => {
  const { dispatch: rightPaneDispatch } = useContext(RightPaneContext);
  const { state: windowState, dispatch: windowDispatch } = useWindowContext();

  useEffect(() => {
    if (props.show) {
      windowDispatch(openWindow(WindowId.Explore));
    } else {
      windowDispatch(closeWindow(WindowId.Explore));
    }
  }, [props.show])

  useEffect(() => {
    if (windowState.find((a) => a.id === WindowId.Explore)) {
      rightPaneDispatch(actionGoToModus(RightPaneModus.Map_Explorer))
    }
  }, [windowState])

  return (null);
}

const RenderOwnerShipDiagram = (props: { show: boolean }) => {
  const { dispatch: rightPaneDispatch } = useContext(RightPaneContext);
  const { state: windowState, dispatch: windowDispatch } = useWindowContext();

  useEffect(() => {
    if (props.show) {
      windowDispatch(openWindow(WindowId.OwnerShipDiagram));
    } else {
      windowDispatch(closeWindow(WindowId.OwnerShipDiagram));
    }
  }, [props.show])

  useEffect(() => {
    if (windowState.find((a) => a.id === WindowId.OwnerShipDiagram)) {
      rightPaneDispatch(actionGoToModus(RightPaneModus.Map_Ownership))
    }
  }, [windowState])

  return (null);
}

const FeatureList = {
  [Feature.BasicMap]: RightPaneModus.Map,
}

function SubMenu() {
  const { dispatch: rightPaneDispatch } = useContext(RightPaneContext)
  const { state: applicationState, hasAccessToFeature } = useContext(ApplicationStateContext)

  let activeFeatures = Object.keys(FeatureList).filter((a) => hasAccessToFeature(a))
  useEffect(() => {
    if (activeFeatures.length === 1) {
      rightPaneDispatch(actionGoToModus(FeatureList[activeFeatures[0]]))
    }
    if (activeFeatures.length < 1) {
      rightPaneDispatch(actionGoToModus(RightPaneModus.Map))
    }
  }, [applicationState])

  if (applicationState.deviceScreenSize === DeviceScreenSize.Phone) {
    return <></>
  }

  if (activeFeatures.length < 2) {
    return <></>
  }

  return (
    <></>
  )
}

function ShareMapBar(props: { show: boolean }) {
  const { dispatch: windowDispatch } = useWindowContext();

  if (!props.show)
    return null;

  return (
    <div className="ExtendedSideBar" >
      <div className='LeftInnerShadow' ></div>
      <SidePanelScrolling>
        <ProtectedFeature feature={Feature.SaveMap} contentsIfNoAccess={<></>}>
          <ExtendedMenuButton className={'invers'} style={{ marginTop: "15px" }} onClick={() => windowDispatch(openWindow(WindowId.SaveMapDialog))} toolTip={Localization.getText("Download")} ><img style={{ height: "100%", background: "#f4f4f4", cursor: "pointer", borderRadius: "5pt" }} src={Download} /></ExtendedMenuButton>
        </ProtectedFeature>
        <ProtectedFeature feature={Feature.SaveLink} contentsIfNoAccess={<></>}>
          <ExtendedMenuButton className='ExtendedMenuButton invers' style={{ marginTop: "15px" }} onClick={() => {
            if (Cookies.getCookieBoolean(MitCookies.RememberMapLinkGDPRAccept)) {
              windowDispatch(openWindow(WindowId.SaveLinkDialog))
            } else {
              windowDispatch(openWindow(WindowId.GDPRNoticeApproval, {
                cookie: MitCookies.RememberMapLinkGDPRAccept,
                acceptCallback: () => windowDispatch(openWindow(WindowId.SaveLinkDialog))
              }));
            }
          }} toolTip={Localization.getText("Get Link")} ><img style={{ height: "100%", background: "#f4f4f4", cursor: "pointer", borderRadius: "5pt" }} src={GetLink} /></ExtendedMenuButton>
        </ProtectedFeature>
        <ProtectedFeature feature={Feature.MapLinkOverview} contentsIfNoAccess={<></>}>
          <ExtendedMenuButton
            className='ExtendedMenuButton invers'
            style={{ marginTop: "15px" }}
            onClick={() => windowDispatch(openWindow(WindowId.MapLinkOverview))}
            toolTip={Localization.getText("My shared map links")}
          >
            <MIBIcon icon="mapLink" />
          </ExtendedMenuButton>
        </ProtectedFeature>
      </SidePanelScrolling>
    </div>
  )
}

function SubSubMenuMap(props: { show: boolean }) {
  const { state: rightPaneState, dispatch: rightPaneDispatch } = useContext(RightPaneContext);
  const { state: windowState, dispatch: windowDispatch } = useWindowContext();

  if (!props.show) { return null }

  function isActive(a: RightPaneModus) {
    let splited = rightPaneState.current.split("_")
    if (splited.map((a, b, c) => c.slice(0, (b + 1)).join("_")).includes(a)) {
      return true
    }
    return false
  }

  function isWindowActive(a: WindowId) {
    if (windowState.find((e) => e.id === a)) {
      return true
    }
    return false
  }

  function toogleWindow(a: WindowId, options?: {}) {
    if (isWindowActive(a)) {
      ActionTracker.track("RightPane", "Window", "Close", { windowId: WindowId[a] })
      windowDispatch(closeWindow(a))
      return
    }
    ActionTracker.track("RightPane", "Window", "Open", { windowId: WindowId[a] })
    windowDispatch(openWindow(a, options))
  }

  function isNewWindowActive(wId: WindowId) {
    return !!windowState.find((a) => a.id === wId)
  }
  function toogleNewWindow(wId: WindowId, options?: {}) {
    if (isNewWindowActive(wId)) {
      ActionTracker.track("RightPane", "Window", "Close", { windowId: WindowId[wId] })
      windowDispatch(closeWindow(wId))
      return
    }
    ActionTracker.track("RightPane", "Window", "Open", { windowId: WindowId[wId] })
    windowDispatch(openWindow(wId, options))
  }



  return (
    <div className="SidePanel" >
      <div className='MainIcon'>

        <TSwitch
          NS={<img src='Estate Explorer favikon hvid.svg' style={{ width: "100%" }} />}
          DF={<img src='favicon.png' style={{ width: "100%" }} />}
        />

      </div>
      <VLine color={"white"} />
      <SidePanelScrolling>
        <ProtectedFeature feature={Feature.BasicMap} contentsIfNoAccess={<></>}>
          <MenuButton onClick={() => rightPaneDispatch(actionToggleModus(RightPaneModus.Map_Layer))} className={"MenuButton " + (isActive(RightPaneModus.Map_Layer) ? "active" : "")} toolTip={Localization.getText("Layers")}
            active={isActive(RightPaneModus.Map_Layer)}
            activeArrow={true}
          >
            <TSwitch NS={<NSIcons src={"NS/MenuIcons/Kortlag_layers.svg"} fill={isActive(RightPaneModus.Map_Layer)} />}
              DF={<MIBIcon icon="Layers" variant={isActive(RightPaneModus.Map_Layer) ? "Bold" : undefined} />} />
          </MenuButton>
        </ProtectedFeature>
        <ProtectedFeature feature={Feature.ExplorerDiscover} contentsIfNoAccess={<></>}>
          <MenuButton onClick={() => rightPaneDispatch(actionToggleModus(RightPaneModus.Map_Discover))} className={"MenuButton " + (isActive(RightPaneModus.Map_Discover) ? "active" : "")} toolTip={Localization.getText("Discover")}
            active={isActive(RightPaneModus.Map_Discover)}
            activeArrow={true}
          >
            <TSwitch NS={<NSIcons src={"NS/MenuIcons/Undersoeg_binoculars.svg"} fill={isActive(RightPaneModus.Map_Discover)} />} DF={<MIBIcon icon="Discover" variant={isActive(RightPaneModus.Map_Discover) ? "Bold" : undefined} />} />
          </MenuButton>
        </ProtectedFeature>
        <ProtectedFeature feature={Feature.MeasurementTool} contentsIfNoAccess={<></>} >
          <MenuButton onClick={() => {
            if (!windowState.find((a) => a.id === WindowId.BNBOMarkAreaEditor || a.id === WindowId.BNBOAreaEditor)) {
              rightPaneDispatch(actionToggleModus(RightPaneModus.Map_Measure))
            } else {
              message.info("Can't open drawModus, while Erstatnings Editor is active")
            }
          }} className={"MenuButton " + (isActive(RightPaneModus.Map_Measure) ? "active" : "")} toolTip={Localization.getText("Draw")}
            active={isActive(RightPaneModus.Map_Measure)}
            activeArrow={true}
          >
            <TSwitch NS={<NSIcons src="NS/MenuIcons/Tegn_pencil.svg" fill={isActive(RightPaneModus.Map_Measure)} />} DF={<MIBIcon icon="Draw" variant={isActive(RightPaneModus.Map_Measure) ? "Bold" : undefined} />} />
          </MenuButton> {/* <MdTraffic /> */}
        </ProtectedFeature>
        <ProtectedFeature feature={Feature.POI} contentsIfNoAccess={<></>} >
          <MenuButton onClick={() => rightPaneDispatch(actionToggleModus(RightPaneModus.Map_POI))} className={"MenuButton " + (isActive(RightPaneModus.Map_POI) ? "active" : "")} toolTip={"POI"}
            active={isActive(RightPaneModus.Map_POI)}
            activeArrow={true}
          >
            <TSwitch NS={<NSIcons src="NS/MenuIcons/POI_bookmark-star.svg" fill={isActive(RightPaneModus.Map_POI)} />} DF={<MIBIcon icon="POI" variant={isActive(RightPaneModus.Map_POI) ? "Bold" : undefined} />} />
          </MenuButton>
        </ProtectedFeature>
        <TSwitch NS={<></>} DF={
          <VLine color={"white"} />
        } />

        {/* Primary features - applicable for most customers */}
        <ProtectedFeature feature={Feature.ExplorerExplore} contentsIfNoAccess={<></>}>
          <MenuButton onClick={() => toogleNewWindow(WindowId.Explore)} className={"MenuButton " + (isNewWindowActive(WindowId.Explore) ? "active" : "")} toolTip={Localization.getText("Explore")}>
            <TSwitch NS={<NSIcons src="NS/MenuIcons/Explore_rocket-takeoff.svg" fill={isNewWindowActive(WindowId.Explore)} />} DF={<MIBIcon icon="Explorer" variant={isNewWindowActive(WindowId.Explore) ? "Bold" : undefined} />} />
          </MenuButton>
        </ProtectedFeature>
        <ProtectedFeature feature={Feature.ExplorerOwnership} contentsIfNoAccess={<></>}>
          <MenuButton onClick={() => toogleNewWindow(WindowId.OwnerShipDiagram)} className={"MenuButton " + (isNewWindowActive(WindowId.OwnerShipDiagram) ? "active" : "")} toolTip={Localization.getText("Ownership")}>
            <TSwitch NS={<NSIcons src="NS/MenuIcons/Ejerskab_diagram-3.svg" fill={isNewWindowActive(WindowId.OwnerShipDiagram)} />} DF={<MIBIcon icon="Ownership" variant={isNewWindowActive(WindowId.OwnerShipDiagram) ? "Bold" : undefined} />} />
          </MenuButton>
        </ProtectedFeature>
        <ProtectedFeature feature={Feature.MapPlot} contentsIfNoAccess={<></>}>
          <MenuButton onClick={() => toogleNewWindow(WindowId.PlotScreen)} className={"MenuButton " + (isNewWindowActive(WindowId.PlotScreen) ? "active" : "")} toolTip={Localization.getText("Plot")} >
            <MIBIcon icon="Plot" variant={isNewWindowActive(WindowId.PlotScreen) ? "Bold" : undefined} />
          </MenuButton>
        </ProtectedFeature>
        <ProtectedFeature feature={Feature.Datarapport} contentsIfNoAccess={<></>}>
          <MenuButton onClick={() => toogleWindow(WindowId.EjendomskortDialog)} className={"MenuButton " + (isWindowActive(WindowId.EjendomskortDialog) ? "active" : "")} toolTip={Localization.getText("Data report")} >
            <MIBIcon icon="DataRapports" variant={isWindowActive(WindowId.EjendomskortDialog) ? "Bold" : undefined} />
          </MenuButton>
        </ProtectedFeature>
        <ProtectedFeature feature={Feature.ConflictSearch} contentsIfNoAccess={<></>}>
          <MenuButton onClick={() => toogleWindow(WindowId.ConflictSearchDialog)} className={"MenuButton " + (isWindowActive(WindowId.ConflictSearchDialog) ? "active" : "")} toolTip={Localization.getText("Conflict search")} >
            <MIBIcon icon="ConflictSearch" variant={isWindowActive(WindowId.ConflictSearchDialog) ? "Bold" : undefined} />
          </MenuButton>
        </ProtectedFeature>

        {/* Extra optional products - applicable for specific customers */}
        <ProtectedFeature feature={Feature.JPBTool} contentsIfNoAccess={<></>} >
          <MenuButton onClick={() => toogleWindow(WindowId.JPBTool)} className={"MenuButton " + (isWindowActive(WindowId.JPBTool) ? "active" : "")} toolTip={Localization.getText("Land Price Calculator")}>
            <MIBIcon icon="JPB" variant={isWindowActive(WindowId.JPBTool) ? "Bold" : undefined} />
          </MenuButton>
        </ProtectedFeature>
        <ProtectedFeature feature={Feature.JPBMolbakIndexAllowWindow} contentsIfNoAccess={<></>} >
          <MenuButton onClick={() => toogleWindow(WindowId.JPBPriceIndexSource, { showAllLandsdele: true })} className={"MenuButton " + (isWindowActive(WindowId.JPBPriceIndexSource) ? "active" : "")} toolTip={Localization.getText("Mølbak index")}>
            <MIBIcon icon="molbakIndex" />
          </MenuButton>
        </ProtectedFeature>
        <ProtectedFeature feature={Feature.TravelTimeMultiple} contentsIfNoAccess={<></>}>
          <MenuButton onClick={() => toogleWindow(WindowId.PointDistanceTable, { dialogMode: "Polygons" })} className={"MenuButton " + (isWindowActive(WindowId.PointDistanceTable) ? "active" : "")} toolTip={Localization.getText("abbreviation:Combined catchment area")}>
            <TSwitch NS={<NSIcons src={"NS/MenuIcons/rejsetid_stopwatch.svg"} fill={isWindowActive(WindowId.PointDistanceTable)} />} DF={<MIBIcon icon="Catchment" variant={isWindowActive(WindowId.PointDistanceTable) ? "Bold" : undefined} />} />
          </MenuButton>
        </ProtectedFeature>
        <ProtectedFeature feature={Feature.BNBOTool} contentsIfNoAccess={<></>} >
          <MenuButton onClick={() => toogleNewWindow(WindowId.BNBOSFEStatus)} className={"MenuButton " + (isNewWindowActive(WindowId.BNBOSFEStatus) ? "active" : "")} toolTip={"BNBO"}>
            <MIBIcon icon="BNBO"
              variant={isNewWindowActive(WindowId.BNBOSFEStatus) ? "Bold" : undefined} />
          </MenuButton>
        </ProtectedFeature>
        <ProtectedFeature feature={Feature.FRPTool} contentsIfNoAccess={<></>} >
          <MenuButton onClick={() => toogleNewWindow(WindowId.FRPAnnoteringsDialog)} className={"MenuButton " + (isNewWindowActive(WindowId.FRPAnnoteringsDialog) ? "active" : "")} toolTip={"FRP"}>
            <MIBIcon icon="FRP"
              variant={isNewWindowActive(WindowId.FRPAnnoteringsDialog) ? "Bold" : undefined} />
          </MenuButton>
        </ProtectedFeature>
        <ProtectedFeature feature={Feature.PLATool} contentsIfNoAccess={<></>} >
          <MenuButton onClick={() => toogleNewWindow(WindowId.PLAWindow)} className={"MenuButton " + (isNewWindowActive(WindowId.PLAWindow) ? "active" : "")} toolTip={Localization.getText("PlanIT")}>
            <MIBIcon icon="PLA" variant={isNewWindowActive(WindowId.PLAWindow) ? "Bold" : undefined} />
          </MenuButton>
        </ProtectedFeature>

        {/* Special features - applicable for specific customers or use cases */}
        <ProtectedFeature feature={Feature.Servituterklaering} contentsIfNoAccess={<></>}>
          <MenuButton onClick={() => toogleWindow(WindowId.Servituterklaering)} className={"MenuButton " + (isWindowActive(WindowId.Servituterklaering) ? "active" : "")} toolTip={"Servituterklæring"}>
            <MIBIcon icon="ServitutErklæring" variant={isWindowActive(WindowId.Servituterklaering) ? "Bold" : undefined} />
          </MenuButton>
        </ProtectedFeature>
        <ProtectedFeature feature={Feature.SpatialExport} contentsIfNoAccess={<></>}>
          <MenuButton onClick={() => toogleWindow(WindowId.SpatialSelection)} className={"MenuButton " + (isWindowActive(WindowId.SpatialSelection) ? "active" : "")} toolTip={"Udvælg"}>
            <TSwitch
              NS={<NSIcons src={"NS/MenuIcons/Udvaelg punkt_pin-map.svg"} fill={isWindowActive(WindowId.SpatialSelection)} />}
              DF={<MIBIcon icon="CircleSelect" variant={isWindowActive(WindowId.SpatialSelection) ? "Bold" : undefined} />}
            />
          </MenuButton>
        </ProtectedFeature>
        <ProtectedFeature feature={Feature.LayerFunctions} contentsIfNoAccess={<></>}>
          <MenuButton onClick={() => toogleNewWindow(WindowId.LayerFunctions)} className={"MenuButton " + (isNewWindowActive(WindowId.LayerFunctions) ? "active" : "")} toolTip={Localization.getText("Layer Functions")}>
            <MIBIcon icon="LayerFunctions" variant={isNewWindowActive(WindowId.LayerFunctions) ? "Bold" : undefined} />
          </MenuButton>
        </ProtectedFeature>
        <ProtectedFeature feature={Feature.GeodataReport} contentsIfNoAccess={<></>} >
          <MenuButton onClick={() => toogleWindow(WindowId.DemographyReportDialog)} className={"MenuButton " + (isWindowActive(WindowId.DemographyReportDialog) ? "active" : "")} toolTip={Localization.getText("Demography")}>
            <TSwitch NS={<NSIcons src={"NS/MenuIcons/Demografi_people.svg"} fill={isWindowActive(WindowId.DemographyReportDialog)} />} DF={<MIBIcon icon="Demographics" variant={isWindowActive(WindowId.DemographyReportDialog) ? "Bold" : undefined} />} />
          </MenuButton>
        </ProtectedFeature>
        <ProtectedFeature feature={Feature.JobModule} contentsIfNoAccess={<></>}>
          <MenuButton onClick={() => toogleNewWindow(WindowId.JobServiceInsider)} className={"MenuButton " + (isNewWindowActive(WindowId.JobServiceInsider) ? "active" : "")} toolTip={Localization.getText("Job Service")}>
            <MIBIcon icon="JobService" variant={isWindowActive(WindowId.JobServiceInsider) ? "Bold" : undefined} />
          </MenuButton>
        </ProtectedFeature>
        <ProtectedFeature feature={Feature.JPBIndexTool} contentsIfNoAccess={<></>} >
          <MenuButton onClick={() => toogleWindow(WindowId.JPBIndexBuilder)} className={"MenuButton " + (isWindowActive(WindowId.JPBIndexBuilder) ? "active" : "")} toolTip={"JPB Index Builder"}>
            <MIBIcon icon="inspectFeature" />
          </MenuButton>
        </ProtectedFeature>

      </SidePanelScrolling>
      <VLine color={"white"} />
      <div className='SettingsMore'>
        <div className='MenuButton' onPointerDown={(e) => e.stopPropagation()} onClick={() => rightPaneDispatch(actionToggleBurgerMenu())}>
          <MIBIcon icon="Menu" />
        </div>
      </div>
    </div>
  )
}

function NSIcons(props: { src: string, fill?: boolean }) {
  return (
    <img src={props.src.replace(".", (props.fill ? "-fill." : "."))} style={{ width: "100%" }} />
  )
}




function Discover(props: { show: boolean }) {
  let { state, dispatch } = useContext(MapitStateContext)

  useEffect(() => {
    return () => dispatch(actionSetMapInteractionStateDefault())
  }, [props.show])

  if (!props.show) {
    return null
  }

  function handleClick(x: MapInteractionState) {
    if (x !== state.mapInteractionState) {
      dispatch(actionSetMapInteractionState(x))
    } else {
      dispatch(actionSetMapInteractionStateDefault())
    }
  }

  let discPrefix = "NS/DiscoverIcons/"
  const Buttons = [
    { text: "Add Pin", icon: <MIBIcon icon="point" />, action: MapInteractionState.ClickToSetMarker, feature: undefined },
    { text: "Info", icon: <MIBIcon icon="propertyInfo" />, action: MapInteractionState.ClickToShowPropertyInfo, feature: Feature.PropertyInfo },
    { text: "Oblique Photo", icon: <MIBIcon icon="obliquePhoto" />, action: MapInteractionState.ClickToShowObliquePhotos, feature: Feature.ObliquePhoto },
    { text: "Kortudsnit", icon: <MIBIcon icon="kortudsnit" />, action: MapInteractionState.Kortudsnit, feature: Feature.Kortudsnit },
    { text: "Street Viewer", icon: <MIBIcon icon="streetView" />, action: MapInteractionState.ClickToShowStreetView, feature: Feature.StreetView },
    { text: "Travel Time", nsIcon: <img src={discPrefix + "rejsetid_stopwatch-fill_45465B.svg"} />, icon: <MIBIcon icon="catchment" />, action: MapInteractionState.ClickToShowTravelTimePolygons, feature: Feature.TravelTime },
    { text: "Real estate", nsIcon: <img src={discPrefix + "vurderingsejendom_cash-coin_45465B.svg"} />, icon: <MIBIcon icon="visVurderingsEjendom" />, action: MapInteractionState.HentVurderingsEjendom, feature: Feature.VisVurderingsejendom },
    { text: "Cadaster", icon: <MIBIcon icon="visMatrikel" />, action: MapInteractionState.HentMatrikel, feature: Feature.VisMatrikel },
    { text: "Total real estate", nsIcon: <img src={discPrefix + "samlet fast ejendom_layout-wtf_45465B.svg"} />, icon: <MIBIcon icon="visSamletFastEjendom" />, action: MapInteractionState.HentSamletFastEjendom, feature: Feature.VisSamletFastEjendom },
    { text: "Historiskekort", icon: <MIBIcon icon="historiskekort" />, action: MapInteractionState.HistoriskeKort, feature: Feature.LinkHistoriskeKort },
    { text: "Dot Info", nsIcon: <img src={discPrefix + "punktinfo_info-circle-fill.svg"} />, icon: <MIBIcon icon="dotInfo" />, action: MapInteractionState.EnforceFeatureLayerPopup, feature: undefined },
    { text: "Point Distance", icon: <MIBIcon icon="pointDistance" />, action: MapInteractionState.ClickToShowPointDistanceTable, feature: Feature.TravelTimeFromPoint },
    { text: "QueryFeatures", icon: <MIBIcon icon="inspectFeature" />, action: MapInteractionState.QueryFeatures, feature: Feature.Debugging },
    // TODO: Add https://maplibre.org/maplibre-gl-js-docs/example/queryrenderedfeatures/
  ]

  return (
    <div className='ExtendedSideBar' >
      <div className='LeftInnerShadow' ></div>
      <SidePanelScrolling>
        {Buttons.map((a) => {
          if (a.feature == undefined) {
            return (
              <Fragment key={a.text}>
                <ExtendedMenuButton className={(a.action === state.mapInteractionState ? " active" : "")} onClick={() => handleClick(a.action)} toolTip={Localization.getText(a.text)}>
                  <TSwitch DF={a.icon} NS={a.nsIcon} />
                </ExtendedMenuButton>
              </Fragment>
            )
          }
          return (
            <ProtectedFeature key={a.text} feature={a.feature} contentsIfNoAccess={<></>} >
              <ExtendedMenuButton className={(a.action === state.mapInteractionState ? " active" : "")} onClick={() => handleClick(a.action)} toolTip={Localization.getText(a.text)}>
                <TSwitch DF={a.icon} NS={a.nsIcon} />
              </ExtendedMenuButton>
            </ProtectedFeature>
          )
        })}
      </SidePanelScrolling>
    </div>
  )
}



function POI(props: { show: boolean }) {
  const { state: mapitState, dispatch: mapitStateDispatch } = useContext(MapitStateContext);
  const { dispatch: appMessageDispatch } = useContext(AppMessagesContext);
  const { dispatch: rightPaneDispatch } = useContext(RightPaneContext)

  if (!props.show) {
    return <></>
  }

  // function mapitStateDispatch(arg0: any) {
  //   throw new Error('Function not implemented.');
  // }

  return (<div className='ExtendedSideBar'>
    <div className='LeftInnerShadow' ></div>
    <PoiSelector
      onSavePoisAsLayer={async (poiTypes: string[]) => {
        const createAsSingleLayer: boolean = true;
        ActionTracker.track("MapitPOI", "POI", "saveAsLayer", { poiTypes: [...poiTypes] });
        if (createAsSingleLayer) {
          let bounds: any = mapitState.map.getBounds();
          let bboxMap: any = bounds.toArray();
          let bbox = [...bboxMap[0], ...bboxMap[1]];
          let featureCollection = await (new DynamicDataDrivenLayerPOI({ label: "pois", layers: JSON.stringify(poiTypes) })).getDataForBBOX(bbox);
          let title = poiTypes.reduce((result, poi, idx) => {
            let label = POIS[poi][Localization.getLanguage()];
            return result + (idx > 0 ? ", " : "") + label;
          }, "")
          let newLayerInfo = LayerFunc.createLayerInfoFromGeoJsonFeatureCollection(featureCollection, title);
          newLayerInfo.styling = { ...newLayerInfo.styling, "markerType": MarkerType.Icon, "iconByProperty": "icon" };
          mapitStateDispatch(actionAddDataLayer(newLayerInfo));
          // Hide the POI's that was currenly shown - and now shown as a data layer.
          mapitStateDispatch(actionSetPoiTypesToShow([]));
          // Show layer list such that new layer can be seen
          rightPaneDispatch(actionToggleModus(RightPaneModus.Map_Layer))
          appMessageDispatch(actionSetInfoMessage(Localization.getFormattedText("Pois has been copied to a new layer '{title}'", { title })));
        }
      }}
    />
  </div>
  )
}

function BurgerBtn(props: {
  icon: React.ReactElement,
  text: string,
  onClick: () => void,
  onDoubleClick?: () => void,
}) {
  return (
    <div className='BurgerBtn' onDoubleClick={props.onDoubleClick} onClick={props.onClick}>
      <div className='icon' >{props.icon}</div>
      <div className='text' >{props.text}</div>
    </div>
  )
}

function BurgerMenu(props: { show: boolean, setShowDebugModal: (show: boolean) => void }) {
  const { state: mapitState } = useContext(MapitStateContext)
  const { state: bnboState } = useContext(BNBOContext)
  const burgerMenuId = useId()
  const { state: licensingState, dispatch: licensingDispatch } = useContext(LicensingContext)
  const { state: sessionState, dispatch: sessionDispatch } = useContext(SessionContext)
  const { dispatch: helpStateDispatch } = useContext(UserHelpContext);
  const { dispatch: rightPaneDispatch } = useContext(RightPaneContext)
  const { dispatch: appMessageDispatch } = useContext(AppMessagesContext)

  const { dispatch: windowDispatch } = useWindowContext();

  // showDebugModal is managed by RightPane; do not keep local state here

  useEffect(() => {
    if (props.show) {
      const closeOutside = (ev: PointerEvent) => {
        const elem = document.getElementById(burgerMenuId)
        if (elem?.contains(ev.target as HTMLElement)) {
          rightPaneDispatch(actionToggleBurgerMenu(false))
          document.removeEventListener('click', closeOutside)
        }
        return
      }
      document.addEventListener('click', closeOutside);
      return () => document.removeEventListener('click', closeOutside)
    }
  }, [props.show])



  if (!props.show) {
    return <></>
  }

  return (<div className='BurgerMenu' id={burgerMenuId}>
    {/* <div className="BurgerHeader">Menu</div> */}
    <LicenseStateCompact />
    <LanguageSelector />
    <div className='scroll'>
      <ProtectedFeature feature={Feature.BNBOToolAdmin} contentsIfNoAccess={<></>} >
        <BurgerBtn icon={<MIBIcon icon="SwitchLicense" />} onClick={() => { windowDispatch(openWindow(WindowId.BNBODialog)) }} text={"BNBO Admin"} />
      </ProtectedFeature>
      <ProtectedFeature feature={Feature.FRPToolAdmin} contentsIfNoAccess={<></>} >
        <BurgerBtn icon={<MIBIcon icon="SwitchLicense" />} onClick={() => { windowDispatch(openWindow(WindowId.FRPAdminDialog)) }} text={"FRP Admin"} />
      </ProtectedFeature>
      <ProtectedFeature feature={Feature.PLAToolAdmin} contentsIfNoAccess={<></>} >
        <BurgerBtn icon={<MIBIcon icon="SwitchLicense" />} onClick={() => { windowDispatch(openWindow(WindowId.PLAAdminDialog)) }} text={Localization.getText("PLA Admin")} />
      </ProtectedFeature>
      <ProtectedFeature feature={Feature.JobModuleGlobalAdmin} contentsIfNoAccess={<></>} >
        <BurgerBtn icon={<MIBIcon icon="SwitchLicense" />} onClick={() => { windowDispatch(openWindow(WindowId.JobsAdminDialog)) }} text={"Jobs Admin"} />
      </ProtectedFeature>
      <BurgerBtn icon={<MIBIcon icon="information" />} onClick={() => { windowDispatch(openWindow(WindowId.InformationWindow)); }} text={Localization.getText("Info Page")} />
      <ProtectedFeature feature={Feature.GettingStarted} contentsIfNoAccess={<></>}>
        <BurgerBtn icon={<MIBIcon icon="question" />} onClick={() => {
          const contactInformation = SettingsManager.getSystemSetting("contactInformation");
          const linkToManual = contactInformation && contactInformation.linkToManual ? contactInformation.linkToManual : "";
          window.open(linkToManual, '_blank')!.focus();
        }} text={Localization.getText("Getting Started")} />
      </ProtectedFeature>
      <ProtectedFeature feature={Feature.GettingStarted} contentsIfNoAccess={<></>}>
        <BurgerBtn icon={<MIBIcon icon="question" />} onClick={() => helpStateDispatch(showReleases())} text={Localization.getText("Welcome to Mapit")} />
      </ProtectedFeature>
      <ProtectedFeature feature={Feature.ShowReleases} contentsIfNoAccess={<></>}>
        <BurgerBtn icon={<MIBIcon icon="question" />} onClick={() => helpStateDispatch(showUserGuide())} text={Localization.getText("Releases")} />
      </ProtectedFeature>
      <ProtectedFeature feature={Feature.SaveMap} contentsIfNoAccess={<></>}>
        <BurgerBtn icon={<MIBIcon icon="saveMap" />} onClick={() => windowDispatch(openWindow(WindowId.SaveMapDialog))} text={Localization.getText("Save map")} />
      </ProtectedFeature>
      <ProtectedFeature feature={Feature.SaveMapCloud} contentsIfNoAccess={<></>}>
        <BurgerBtn icon={<MIBIcon icon="cloudUpload" />} onClick={() => windowDispatch(openWindow(WindowId.CloudSaveDialog))} text={Localization.getText("Save map on Cloud")} />
      </ProtectedFeature>
      <ProtectedFeature feature={Feature.SaveLink} contentsIfNoAccess={<></>}>
        <BurgerBtn icon={<MIBIcon icon="mapLink" />} onClick={() => {
          if (Cookies.getCookieBoolean(MitCookies.RememberMapLinkGDPRAccept)) {
            windowDispatch(openWindow(WindowId.SaveLinkDialog))
          } else {
            windowDispatch(openWindow(WindowId.GDPRNoticeApproval, {
              cookie: MitCookies.RememberMapLinkGDPRAccept,
              acceptCallback: () => windowDispatch(openWindow(WindowId.SaveLinkDialog))
            }));
          }
        }} text={Localization.getText("Generate map link")} />
      </ProtectedFeature>
      <ProtectedFeature feature={Feature.MapLinkOverview} contentsIfNoAccess={<></>}>
        <BurgerBtn
          icon={<MIBIcon icon="mapLink" />}
          onClick={() => windowDispatch(openWindow(WindowId.MapLinkOverview))}
          text={Localization.getText("My shared map links")}
        />
      </ProtectedFeature>





      {/* <BurgerBtn 
            onClick={()=> {mapitStateDispatch(actionSetShowWindow(MapitWindowId.MapSettingsEditor, true))}}
            icon={<BsMap />}
            text={Localization.getText("Menuitem:MapSettings")} /> */}

      <BurgerBtn
        onClick={() => { windowDispatch(openWindow(WindowId.UserSettingsEditor)) }}
        icon={<MIBIcon icon="settings" />}
        text={Localization.getText("Menuitem:UserSettings")} />

      <ProtectedFeature feature={Feature.SettingsCustomer} contentsIfNoAccess={<></>} >
        <BurgerBtn
          onClick={() => { windowDispatch(openWindow(WindowId.CustomerSettingsEditor)) }}
          icon={<MIBIcon icon="customerSettings" />}
          text={Localization.getText("Menuitem:CustomerSettings")} />
      </ProtectedFeature>
      <BurgerBtn icon={<MIBIcon icon="changePassword" />} onClick={() => sessionDispatch(actionSetLoginDialogMode(LoginDialogMode.ChangePassword))} text={Localization.getText("Change Password")} />
      <BurgerBtn icon={<MIBIcon icon="logout" />} onClick={() => sessionDispatch({ type: SessionActionType.Logoff, payload: { userName: sessionState.userName } })} text={Localization.getText("Log Off")} />

      <ProtectedFeature feature={Feature.Debugging} contentsIfNoAccess={<></>}>
        <BurgerBtn icon={<MIBIcon icon="debugging" />} onClick={() => appMessageDispatch(actionSetInfoMessage("Double klick to remove license"))} onDoubleClick={() => {
          licensingDispatch(actionDisableLicense(sessionState.customerRef, sessionState.userRef, licensingState.currentlicense!, () => {
            alert(`License ${licensingState.currentlicense!.product + ":" + licensingState.currentlicense!.productVariant}removed for user ${sessionState.userName}. Logging off`);
          }));
          sessionDispatch(actionLogoff(sessionState.userRef));
        }} text="Remove License" />
        <BurgerBtn icon={<MIBIcon icon="debugging" />} onClick={() => { licensingDispatch(actionSimulateExpiredLicense()) }} text="Sim Expired License" />
        <BurgerBtn icon={<MIBIcon icon="debugging" />} onClick={() => { licensingDispatch(actionSimulateInvalidLicense()) }} text="Sim Invalid License" />
        <BurgerBtn icon={<MIBIcon icon="debugging" />} onClick={() => { console.log(mapitState.layers) }} text="Log Layers" />
        <BurgerBtn icon={<MIBIcon icon="debugging" />} onClick={() => { console.log(mapitState.featureLayers) }} text="Log featuresLayers" />
        <BurgerBtn icon={<MIBIcon icon="debugging" />} onClick={() => { console.log(mapitState.layerHierarchy) }} text="Log layerHierarchy" />
        <BurgerBtn icon={<MIBIcon icon="debugging" />} onClick={() => { console.log(bnboState) }} text="Log BNBO" />
        <BurgerBtn icon={<MIBIcon icon="debugging" />} onClick={() => { windowDispatch(openWindow(WindowId.DebugLayerTester)) }} text="Layer Tester" />
        {/* <BurgerBtn icon={<MIBIcon icon="debugging" />} onClick={() => { windowDispatch(openWindow(WindowId.CompanyInformationDialog, { cvrNr: 25483839 })) }} text="Show Company (25483839)" /> */}
        {/* <BurgerBtn icon={<MIBIcon icon="debugging" />} onClick={() => { windowDispatch(openWindow(WindowId.PersonInformationDialog, { name: "Test", dateOfBirth: new Date("1-1-2000") })) }} text="Show Person (Test)" /> */}
        {/* <BurgerBtn icon={<MIBIcon icon="debugging" />} onClick={() => { appMessageDispatch(actionSetProgressMessage("Text: Set Progress 0", 0)); setTimeout(() => appMessageDispatch(actionClearProgressMessage()), 10000) }} text="Set Progress 0" /> */}
        {/* <BurgerBtn icon={<MIBIcon icon="debugging" />} onClick={() => { appMessageDispatch(actionSetProgressMessage("Text: Set Progress 33", 33)); setTimeout(() => appMessageDispatch(actionClearProgressMessage()), 10000) }} text="Set Progress 33" /> */}
        {/* <BurgerBtn icon={<MIBIcon icon="debugging" />} onClick={() => { appMessageDispatch(actionSetProgressMessage("Text: Set Progress 50", 50)); setTimeout(() => appMessageDispatch(actionClearProgressMessage()), 10000) }} text="Set Progress 50" /> */}
        {/* <BurgerBtn icon={<MIBIcon icon="debugging" />} onClick={() => { appMessageDispatch(actionSetProgressMessage("Text: Set Progress 100", 100)); setTimeout(() => appMessageDispatch(actionClearProgressMessage()), 10000) }} text="Set Progress 100" /> */}
        {/* <BurgerBtn icon={<MIBIcon icon="debugging" />} onClick={() => { appMessageDispatch(actionSetInfoMessage("Text: SetInfoMessage")) }} text="SetInfoMessage" /> */}
        {/* <BurgerBtn icon={<MIBIcon icon="debugging" />} onClick={() => { appMessageDispatch(actionSetErrorMessage("Text: SetErrorMessage")) }} text="SetErrorMessage" /> */}
        <BurgerBtn icon={<MIBIcon icon="debugging" />} onClick={() => { MitStorage.clearAll() }} text="Clear LocalStorage" />
        <BurgerBtn icon={<MIBIcon icon="debugging" />} onClick={() => { MitStorage.getKeys().filter((a) => a.startsWith("ADM-Pos-")).forEach((a) => MitStorage.clearValue(a)) }} text="Clear Positions" />
        <BurgerBtn icon={<MIBIcon icon="debugging" />} onClick={() => { windowDispatch(openWindow(WindowId.Opslag)) }} text="Opslag 🦖" />
        <BurgerBtn icon={<MIBIcon icon="debugging" />} onClick={() => { windowDispatch(openWindow(WindowId.GraphQLDemo)) }} text="GraphQL 📈" />
        <BurgerBtn icon={<MIBIcon icon="debugging" />} onClick={() => { windowDispatch(openWindow(WindowId.PDFInspector)) }} text="PDF Inspector 🦖" />
        <BurgerBtn icon={<MIBIcon icon="debugging" />} onClick={() => { windowDispatch(openWindow(WindowId.BroadcastReceiverDebug)) }} text="Broadcast Debug" />
        <BurgerBtn icon={<MIBIcon icon="debugging" />} onClick={() => { windowDispatch(openWindow(WindowId.LoadedSettings)) }} text="Show Loaded Settings" />
        <BurgerBtn icon={<MIBIcon icon="debugging" />} onClick={() => { windowDispatch(openWindow(WindowId.DemoSideComponents)) }} text="Demoside Componenter" />
        <BurgerBtn icon={<MIBIcon icon="debugging" />} onClick={() => { windowDispatch(openWindow(WindowId.DemoSideIconsMIB)) }} text="Demoside Ikoner 👍" />
        <BurgerBtn icon={<MIBIcon icon="debugging" />} onClick={() => { windowDispatch(openWindow(WindowId.ImageOverlayDebug)) }} text="Image overlays" />
      </ProtectedFeature>

      <ProtectedFeature feature={Feature.AnnotationAuthUser} contentsIfNoAccess={<></>}>
        <BurgerBtn icon={<MIBIcon icon="Annotation" />} onClick={() => windowDispatch(openWindow(WindowId.ANNUnverifiedAnnotations))} text={Localization.getText("Unverified Annotations") || "Annotations"} />
      </ProtectedFeature>
      <ProtectedFeature feature={Feature.SimulateOtherUser} contentsIfNoAccess={<></>}>
        <BurgerBtn icon={<MIBIcon icon="debugging" />} onClick={() => { windowDispatch(openWindow(WindowId.SimulateOtherUser)) }} text="Simulate Other User" />
      </ProtectedFeature>
      <ProtectedFeature feature={Feature.EditAccessRights} contentsIfNoAccess={<></>}>
        <BurgerBtn icon={<MIBIcon icon="debugging" />} onClick={() => { windowDispatch(openWindow(WindowId.UserAccessRights)) }} text="Show Access Rights" />
      </ProtectedFeature>
      <ProtectedFeature feature={Feature.SwapLicense} contentsIfNoAccess={<></>}>
        {Object.keys(licenseVariantToRoles).map((a) => {
          return (<Fragment key={a}>
            <BurgerBtn icon={<MIBIcon icon="switchLicense" />} text={"Switch to " + a} onClick={() => licensingDispatch(actionSwapLicenseVariant(a))} />
          </Fragment>)
        })}
      </ProtectedFeature>
    </div>
  </div>)
}


function CatchmentSideBar() {
  const { state: mapitState, dispatch: mapitStateDispatch } = useContext(MapitStateContext)
  const { state: catchmentState, dispatch: catchmentStateDispatch } = useContext(CatchmentStateContext);
  const { hasAccessToFeature, } = useContext(ApplicationStateContext);
  const { dispatch: appMessageDispatch } = useContext(AppMessagesContext);
  const { state: windowState, dispatch: windowDispatch } = useWindowContext();


  function isWindowActive(a: WindowId) {
    if (windowState.find((e) => e.id === a)) {
      return true
    }
    return false
  }

  return (
    <CatchmentSelector
      showWindow={Boolean(isWindowActive(WindowId.CatchmentSelector))}
      showHideButton={true}
      showDownloadButton={hasAccessToFeature(Feature.TravelTimeDownloadPolygons)}
      showRushHourSelector={hasAccessToFeature(Feature.TravelTimeRushHourMode)}
      showCombinedBikeAndTransit={hasAccessToFeature(Feature.TravelTimeCombinedBikeAndTransit) && catchmentState.calculationMode === CalculationMode.Simple_RegenerateAfterEachParameterChange}
      isCollapsed={false}
      onChange={(modeOfTransport: string, rushHourMode: boolean) => {
        let newState: CatchmentState = { ...catchmentState, selectedModeOfTransport: modeOfTransport, rushHourMode: rushHourMode };
        catchmentStateDispatch(actionSetCatchmentState(newState))
        if (catchmentState.calculationMode === CalculationMode.Simple_RegenerateAfterEachParameterChange) {
          catchmentStateDispatch(actionGenerateCatchmentSimple(newState, mapitState, catchmentState.catchmentLocation!));
        } else {
          windowDispatch(openWindow(WindowId.PointDistanceTable, { dialogMode: "Polygons" }))
          windowDispatch(closeWindow(WindowId.CatchmentSelector))
        }
      }}
      hideCatchments={() => {
        // Hide any polygon layer shown
        if (catchmentState.layerHandle) {
          mapitState.map.removeLayerByHandle(catchmentState.layerHandle as any);
        }
        windowDispatch(closeWindow(WindowId.CatchmentSelector))
        // clear any cached polygons. To allow an easy way of making sure that new User Settings - affecting polygons - have effect the next time the dialog is used.
        CatchmentInterface.clearCache();
      }}
      onDownloadCatchments={() => {
        if (catchmentState.polygons) {
          let json = JSON.stringify(catchmentState.polygons);
          let blob = new Blob([json], { type: "application/json" });
          let fileName = "catchment.json";
          ExportData.downloadBlob(fileName, blob);
        } else {
          appMessageDispatch(actionSetErrorMessage("No catchment to download"));
        }
      }}
      onSaveCatchments={() => {
        const createAsSingleLayer: boolean = false;
        if (createAsSingleLayer) {
          let newLayerInfo = LayerFunc.createLayerInfoFromGeoJsonFeatureCollection(catchmentState.polygons, Localization.getText("Travel Time"));
          mapitStateDispatch(actionAddDataLayer(newLayerInfo));
        } else {
          let layerInfos = (catchmentState.polygons! as any).features.toSorted((a, b) => { return b.properties.time - a.properties.time }).map((ft) => {
            let timeSeconds = ft.properties.time;
            let idx = catchmentState.travelTimes.findIndex((val) => val === timeSeconds);
            let color = catchmentState.colorScale[idx];
            let rushHourText = catchmentState.rushHourMode ? "," + Localization.getText("Rush hour") : "";
            let motText = Localization.getText("ModeOfTransport:" + catchmentState.selectedModeOfTransport || "");
            let layerName = Localization.getFormattedText("Travel Time {mot} ({time} mins)", { mot: motText + rushHourText, time: Math.floor(timeSeconds / 60) });
            let newLayerInfo = LayerFunc.createLayerInfoFromGeoJsonFeature(ft, layerName);
            // set opacity to 0.7
            newLayerInfo.styling.color = chroma(color).alpha(0.7).css();
            newLayerInfo.styling.lineOpacity = 0;
            return newLayerInfo;
          }) as LayerInfo[]
          windowDispatch(openWindow(WindowId.NameOnCreation, { layers: layerInfos }))
          if (catchmentState.layerHandle) {
            mapitState.map.removeLayerByHandle(catchmentState.layerHandle as any);
          }

          windowDispatch(closeWindow(WindowId.CatchmentSelector));
          windowDispatch(closeWindow(WindowId.PointDistanceTable))
        }
      }}
      onToggleShowItemCounts={() => {
        let newState: CatchmentState = { ...catchmentState, showSpatialItemsCounts: !(catchmentState.showSpatialItemsCounts) };
        catchmentStateDispatch(actionSetCatchmentState(newState))
      }}
    />
  )
}

